import type { ReactNode } from "react";
import HeaderUserMenu from "@/components/header/header-user-menu";
import type { useHeaderAuth } from "@/components/header/use-header-auth";

type HeaderAuthSectionProps = Readonly<{
  auth: ReturnType<typeof useHeaderAuth>;
  loggedOutContent: ReactNode;
  className?: string;
}>;

export default function HeaderAuthSection({
  auth,
  loggedOutContent,
  className = "flex items-center gap-3 md:gap-4",
}: HeaderAuthSectionProps) {
  const { isLoggedIn, isLoading, dashboardMenuItems } = auth;

  return (
    <div className={className}>
      {isLoggedIn ? (
        <HeaderUserMenu
          isLoading={isLoading}
          dashboardMenuItems={dashboardMenuItems}
        />
      ) : (
        loggedOutContent
      )}
    </div>
  );
}
